<template>
  <div class="property-editor">
    <button v-if="section.shared == parent.shared" v-on:click="deleteWidget">Delete</button>
    <ul>
      <li v-for="(p, k, i) in widget.properties" :key="'property_'+i.toString()">
        
        <label>{{k}}</label>
        <select v-if="WidgetUtils.getPropertyInputType(k) == GeneralUtils.InputTypes.SELECT" v-model="widget.properties[k]" >
          <option v-for="(o, k, i) in GeneralUtils.EnumMatrix[k]" :key="'p_a'+i.toString" :value="o">{{k}}</option>
        </select>
        <input v-else :type="WidgetUtils.getPropertyInputType(k)" v-model="widget.properties[k]" />
      </li>
    </ul>
    <div v-if="widget.transition.join && !section.shared">
      <ul>
        <li><label>Duration</label><input type="number" v-model="widget.transition[index].duration" /></li>
        <li><label>Delay</label><input type="number" v-model="widget.transition[index].delay" /></li>
        <li>
          <select v-model="widget.transition[index].easeOption">
            <option v-for="(e, _k, j) in GeneralUtils.EasingOptions" :key="'ease_option_'+j.toString()" :value="e">{{_k}}</option>
          </select>
        </li>
        <li>
          <select v-model="widget.transition[index].easeDirection">
            <option v-for="(e, _k, j) in GeneralUtils.EasingDirections" :key="'ease_direction_'+j.toString()" :value="e">{{_k}}</option>
          </select>
        </li>
      </ul>
    </div>
    <div v-else-if="!section.shared">
      <ul>
        <li><label>Duration</label><input type="number" v-model="widget.transition.duration" /></li>
        <li><label>Delay</label><input type="number" v-model="widget.transition.delay" /></li>
        <li>
          <select v-model="widget.transition.easeOption">
            <option v-for="(e, _k, j) in GeneralUtils.EasingOptions" :key="'ease_option_'+j.toString()" :value="e">{{_k}}</option>
          </select>
        </li>
        <li>
          <select v-model="widget.transition.easeDirection">
            <option v-for="(e, _k, j) in GeneralUtils.EasingDirections" :key="'ease_direction_'+j.toString()" :value="e">{{_k}}</option>
          </select>
        </li>
      </ul>
    </div>
    
    <ul v-if="widget.transition.join && !section.shared">
      <li v-for="(t, k, i) in widget.transition[index].values" :key="'transition_'+i.toString()">
        
        <label>{{k}}</label>
        <input :type="WidgetUtils.getPropertyInputType(k)" v-model="widget.transition[index].values[k]" />
        <button v-on:click="deleteTransition(k, widget.transition)">X</button>
      </li>
      <li>
        <select v-model="addedProperty">
          <option value="none">Select a Property</option>
          <option v-for="(p, j) in getAvailablePropertyList(widget.properties, widget.transition[index].values)" :key="'prop_'+j.toString()" :value="p">
            {{p}}
          </option>
        </select>
        <button v-on:click="addTransition(addedProperty, widget.properties, widget.transition)" v-if="addedProperty != 'none'">Add</button>
      </li>
    </ul>
    <ul v-else-if="!section.shared">
      <li v-for="(t, k, i) in widget.transition.values" :key="'transition_'+i.toString()">
        
        <label>{{k}}</label>
        <input :type="WidgetUtils.getPropertyInputType(k)" v-model="widget.transition.values[k]" />
        <button v-on:click="deleteTransition(k, widget.transition)">X</button>
      </li>
      <li>
        <select v-model="addedProperty">
          <option value="none">Select a Property</option>
          <option v-for="(p, j) in getAvailablePropertyList(widget.properties, widget.transition.values)" :key="'prop_'+j.toString()" :value="p">
            {{p}}
          </option>
        </select>
        <button v-on:click="addTransition(addedProperty, widget.properties, widget.transition)" v-if="addedProperty != 'none'">Add</button>
      </li>
    </ul>
  </div>
</template>
<script>
import {EventBus} from '../utils/EventBus.js'
import WidgetUtils from '../utils/WidgetUtils.js'
import GeneralUtils from '../utils/GeneralUtils.js'
export default {
  props: ['widget', 'index', 'section', 'parent'],
  data () {
    return {
      WidgetUtils: WidgetUtils,
      GeneralUtils: GeneralUtils,
      addedProperty: 'none'
    }
  },
  methods: {
    getAvailablePropertyList: function (properties, transitions) {
      var pList = []
      for (var p in properties) {
        if (transitions[p] === undefined && WidgetUtils.getPropertyInputType(p) === GeneralUtils.InputTypes.NUMBER) {
          pList.push(p)
        }
      }
      return pList
    },
    addTransition: function (property, properties, transition) {
      var self = this
      // EventBus.$emit('transition-added', {index: self.index, property: property})
      if (transition.join) {
        for (var i = 0; i < transition.length; i++) {
          transition[i].values[property] = properties[property]
        }
      } else {
        // console.log(transition)
        transition.values[property] = Number(properties[property].toString())
      }
      self.$data.addedProperty = 'none'
      // self.$forceUpdate()
    },
    deleteTransition: function (property, transition) {
      var self = this
      if (transition.join) {
        for (var i = 0; i < transition.length; i++) {
          transition[i].values = GeneralUtils.removeProperty(property, transition[i].values)
        }
      } else {
        transition.values = GeneralUtils.removeProperty(property, transition.values)
      }
      self.$forceUpdate()
    },
    deleteWidget: function () {
      EventBus.$emit('delete-widget', {})
    }
  }
}
</script>
<style lang="scss" scoped>
div.property-editor{
  width: 100% !important;
  > div{
    > input{
      width: 50px;
      float:right;
    }
  }
  > ul {
    > li{
      margin: 8px 0;
      display:block;
      border-top: 1px solid #dddddd;
      > input{
        width: 50px;
        float:right;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/editors/PropertyEditor.vue